import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../../store/hooks/useTypedSelector";
import {formatCountdown} from "../helper";
import {Link} from "react-router-dom";
import {Accordion, Alert} from "react-bootstrap";

interface QBLProps {
    atagParams: string | null,
    viewType?: string | null
    eventKey: string
    ticketOpenMode: string | null
    sourceParams: string | null,
}
const QuickbetLobbyWidget: FC <QBLProps> = ({atagParams, viewType,ticketOpenMode,eventKey, sourceParams}) => {
    const {getJackpotsData} = useAction();
    const {jackpotsData} = useTypedSelector((state) => state.jackpotsReducer);
    const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
    useEffect(()=>{
        getJackpotsData();
    }, [])
    return (
        <>
            {
                jackpotsData.length > 0 ?
                    <Accordion.Item eventKey={eventKey} className='cursor-pointer'>
                        <Accordion.Header>Jackpots</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-group list-group-flush"
                                style={{
                                    listStyle: 'none',
                                    padding: '0'
                                }}
                            >
                                {jackpotsData.map((item: any, index: number) => {
                                    const countdown = formatCountdown(item.operator_time_expires)
                                    return (
                                        <li className={`list-group-item ${index % 2 === 1 ? 'list-item-bg-dark' : 'list-item-bg-light'}`}
                                            key={index}>
                                            <Link
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'left',
                                                    alignItems: ' center'
                                                }}
                                                to={(() => {
                                                    let url = `jackpot/${item.code}`;
                                                    const params = new URLSearchParams();

                                                    if (atagParams) params.append('atag', atagParams);
                                                    if (sourceParams) params.append('source', sourceParams);
                                                    if (viewType) params.append('viewType', viewType);
                                                    const queryString = params.toString();
                                                    if (queryString) url += `?${queryString}`;

                                                    return url;
                                                })()}
                                                className='d-flex justify-content-between align-items-center text-decoration-none sidebar-ticket-link text-green'
                                                target={ticketOpenMode === 'redirect' ? '_blank' : undefined}
                                            >
                                                <img
                                                    src={`${item.preview_img}`}
                                                    onError={(e) => {
                                                        e.currentTarget.src = toAbsoluteUrl('/assets/img/events/league/F2964C.png');
                                                    }}
                                                    width='35'
                                                    height='35'
                                                    alt="QBX-logo"
                                                    style={{
                                                        borderRadius: "1rem"
                                                    }}
                                                />
                                                <div style={{marginLeft: '10px'}}
                                                     className='text-center text-green'>
                                                    {item.title.length > 0 ? item.title : null}
                                                </div>
                                            </Link>
                                        </li>
                                    )
                                })}
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    : null
            }
        </>
    );

}

export default QuickbetLobbyWidget;
